import React, {createContext} from 'react';

import {ArrowNavigationContext} from '@pb/kit-hook-use-arrow-navigation';

import type {Item} from './typedef';
import type {ArrowNavigationContextType} from '@pb/kit-hook-use-arrow-navigation';
import type {Context, ReactNode} from 'react';


export type StripOfPillsContextProps = {
    addPill: (pill: Item) => void,
    removePill: (pill: Item) => void,
    arrowNavigationContext: ArrowNavigationContextType,
};

export const StripOfPillsContext: Context<StripOfPillsContextProps> = createContext<StripOfPillsContextProps>({
    addPill: () => {},
    removePill: () => {},
    arrowNavigationContext: {
        addItem: () => {},
        removeItem: () => {},
        setActiveItem: () => {},
    },
});

StripOfPillsContext.displayName = 'StripOfPillsContext';

export type Props = {
    children: ReactNode,
    context: StripOfPillsContextProps,
};

export const StripOfPillsContextProvider = (props: Props) => {
    const {
        children,
        context,
    } = props;


    return (
        <StripOfPillsContext.Provider value={context}>
            <ArrowNavigationContext.Provider value={context.arrowNavigationContext}>
                {children}
            </ArrowNavigationContext.Provider>
        </StripOfPillsContext.Provider>
    );
};

StripOfPillsContextProvider.displayName = 'StripOfPillsContextProvider';
